/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpBigQueryResourceMaterializedViewsInner {
  /**
  * Materialized view name.
  */
  'name'?: string;
  /**
  * Materialized view type.
  */
  'type'?: string;
  /**
  * Number of rows in the materialized view.
  */
  'numRows'?: number;
  /**
  * Materialized view logical storage size in bytes.
  */
  'totalLogicalBytes'?: number;
  /**
  * Materialized view physical storage size in bytes.
  */
  'totalPhysicalBytes'?: number;
  /**
  * Active logical storage size in bytes.
  */
  'activeLogicalBytes'?: number;
  /**
  * Long-term logical storage size in bytes.
  */
  'longTermLogicalBytes'?: number;
  /**
  * Active physical storage size in bytes.
  */
  'activePhysicalBytes'?: number;
  /**
  * Long-term physical storage size in bytes.
  */
  'longTermPhysicalBytes'?: number;
  /**
  * Materialized view time travel physical storage size in bytes.
  */
  'timeTravelPhysicalBytes'?: number;
  /**
  * Materialized view creation time.
  */
  'creationTime'?: Date;
  /**
  * Materialized view last modification time.
  */
  'lastModifiedTime'?: Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "string",
      "format": ""
    },
    {
      "name": "numRows",
      "baseName": "numRows",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "totalLogicalBytes",
      "baseName": "totalLogicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "totalPhysicalBytes",
      "baseName": "totalPhysicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "activeLogicalBytes",
      "baseName": "activeLogicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "longTermLogicalBytes",
      "baseName": "longTermLogicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "activePhysicalBytes",
      "baseName": "activePhysicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "longTermPhysicalBytes",
      "baseName": "longTermPhysicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "timeTravelPhysicalBytes",
      "baseName": "timeTravelPhysicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "creationTime",
      "baseName": "creationTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "lastModifiedTime",
      "baseName": "lastModifiedTime",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return GcpBigQueryResourceMaterializedViewsInner.attributeTypeMap;
  }

  public constructor() {
  }
}

